import { memo } from 'react';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { jsx as _jsx } from "react/jsx-runtime";
function CallMetadataError({
  children
}) {
  return /*#__PURE__*/_jsx(Alert, {
    "data-test-id": "call-metadata-error",
    type: "warning",
    use: "inline",
    children: children
  });
}
export default /*#__PURE__*/memo(CallMetadataError);